/* ============================================================
   Helper Functions: slideDown, slideUp, getSiblings
   (Required by the submenu toggle logic below)
   ============================================================ */

/* Slide element down (show) */
function slideDown(element, duration = 300) {
  element.style.removeProperty("display");
  let display = window.getComputedStyle(element).display;
  if (display === "none") display = "block";
  element.style.display = display;

  const height = element.offsetHeight;
  element.style.overflow = "hidden";
  element.style.height = "0px";
  element.style.paddingTop = "0px";
  element.style.paddingBottom = "0px";
  element.style.marginTop = "0px";
  element.style.marginBottom = "0px";
  element.offsetHeight; // force reflow

  element.style.transition = `height ${duration}ms ease, padding ${duration}ms ease, margin ${duration}ms ease`;
  element.style.height = height + "px";
  element.style.removeProperty("padding-top");
  element.style.removeProperty("padding-bottom");
  element.style.removeProperty("margin-top");
  element.style.removeProperty("margin-bottom");

  window.setTimeout(() => {
    element.style.removeProperty("height");
    element.style.removeProperty("overflow");
    element.style.removeProperty("transition");
  }, duration);
}

/* Slide element up (hide) */
function slideUp(element, duration = 300) {
  element.style.transition = `height ${duration}ms ease, padding ${duration}ms ease, margin ${duration}ms ease`;
  element.style.overflow = "hidden";
  element.style.height = element.offsetHeight + "px";
  element.offsetHeight; // force reflow

  element.style.height = "0px";
  element.style.paddingTop = "0px";
  element.style.paddingBottom = "0px";
  element.style.marginTop = "0px";
  element.style.marginBottom = "0px";

  window.setTimeout(() => {
    element.style.display = "none";
    element.style.removeProperty("height");
    element.style.removeProperty("padding-top");
    element.style.removeProperty("padding-bottom");
    element.style.removeProperty("margin-top");
    element.style.removeProperty("margin-bottom");
    element.style.removeProperty("overflow");
    element.style.removeProperty("transition");
  }, duration);
}

/* Get all sibling elements except the current one */
function getSiblings(element) {
  return Array.prototype.filter.call(element.parentNode.children, function (sibling) {
    return sibling !== element;
  });
}

/* ============================================================
   Mobile Off-canvas Header / Menu
   ============================================================ */

theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      /* Add a Button For SubMenu Toggle */
      offcanvasMenu.forEach((item) => {
        item.querySelectorAll(".offcanvas__sub_menu").forEach(function (ul) {
          // Guard: don't add a second button if one already exists for this ul
          if (ul.dataset.toggleAdded === "true") return;

          const subMenuToggle = document.createElement("button");
          subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
          subMenuToggle.setAttribute("aria-label", "menu collapse");
          ul.insertAdjacentElement("afterend", subMenuToggle); // places it right after the ul
          ul.dataset.toggleAdded = "true";
        });
      });

      /* Open/Close Menu On Click Toggle Button */
      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.add("open");
        body.style.overflowY = "hidden";
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.remove("open");
        body.style.overflowY = null;
      });

      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        offcanvasMenuitem
          .querySelectorAll(".offcanvas__sub_menu_toggle")
          .forEach(function (toggle) {
            // Guard: don't attach a second listener to the same button
            if (toggle.dataset.listenerAdded === "true") return;
            toggle.dataset.listenerAdded = "true";

            const subMenu = toggle.previousElementSibling; // captured once, reliable reference

            toggle.addEventListener("click", function (e) {
              e.preventDefault();
              const parent = toggle.parentElement;
              if (parent.classList.contains("active")) {
                toggle.classList.remove("active");
                parent.classList.remove("active");
                parent
                  .querySelectorAll(".offcanvas__sub_menu")
                  .forEach(function (sm) {
                    sm.parentElement.classList.remove("active");
                    slideUp(sm);
                  });
              } else {
                toggle.classList.add("active");
                parent.classList.add("active");
                slideDown(subMenu);
                getSiblings(parent).forEach(function (item) {
                  item.classList.remove("active");
                  item
                    .querySelectorAll(".offcanvas__sub_menu")
                    .forEach(function (sm) {
                      sm.parentElement.classList.remove("active");
                      slideUp(sm);
                    });
                });
              }
            });
          });
      });

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            offcanvasHeader.classList.remove("open");
            body.style.overflowY = null;
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          offcanvasHeader.classList.remove("open");
          body.style.overflowY = null;
        }
      });
    };
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();